import React from 'react';

import './ChangePricingPlanTerms.scss';

export interface ChangePricingPlanTermsProps {
  onCancel: () => void;
  onConfirm: () => void;
  onToggleChange: () => void;
  defaultContractLength: number;
  areTermsAccepted: boolean;
}

export const ChangePricingPlanTerms = ({
  onCancel,
  onConfirm,
  onToggleChange,
  defaultContractLength,
  areTermsAccepted,
}: ChangePricingPlanTermsProps) => {
  const termsTitle = t('pricing-plan.change-package.terms.title', {
    length: defaultContractLength,
  });

  return (
    <div className="tos-box change-pricing-plan-terms">
      <a onClick={onCancel} className="close-btn">
        <i className="icon-times" />
      </a>

      <h1>{termsTitle}</h1>
      <div className="tos-desc">
        <p>{t('pricing-plan.change-package.terms.subtitle')}</p>
        <ol>
          <li>{t('pricing-plan.change-package.terms.part-1')}</li>
          <li>{t('pricing-plan.change-package.terms.part-2')}</li>
          <li>{t('pricing-plan.change-package.terms.part-3')}</li>
          <li>{t('pricing-plan.change-package.terms.part-4')}</li>
          <li>{t('pricing-plan.change-package.terms.part-5')}</li>
          <li>{t('pricing-plan.change-package.terms.part-6')}</li>
        </ol>
      </div>

      <div className="form-row-dark">
        <label className="accept-terms checkbox">
          <input type="checkbox" checked={areTermsAccepted} onChange={onToggleChange} />
          <i />
          <span>{t('action.accept-terms')}</span>
        </label>
      </div>

      {areTermsAccepted && (
        <button type="button" className="btn btn-main btn-block" onClick={onConfirm}>
          {t('action.accept')}
        </button>
      )}
    </div>
  );
};
